import {Component, OnInit} from '@angular/core';
import {ReportingInfo} from "../../../lib/models/reporting.model";
import {ReportingService} from "../../../lib/services/reporting.service";
import {UserService} from "../../../lib/services/user.service";
import {
  ActivityIndicatorWithMessages
} from "../../../lib/activity-indicator-with-messages/activity-indicator-with-messages.component";

@Component({
  selector: 'ms-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.scss'],
  standalone: false
})
export class ReportingComponent implements OnInit{

  public isLoading: boolean = false;
  public messages: Array<ActivityIndicatorWithMessages> = [];

  private availableReporting: Array<ReportingInfo> = [
    {
      name: 'getAllUsersByGroupId',
      creationDate: '2023-04-22',
      title: 'Liste des utilisateurs',
      description: "Liste l'ensemble des utilisateurs actifs par groupeId",
      isActive: true,
      exportedColumns: ['Groupe Id', 'Email', 'Taille de la db base', 'Taille de la db patient', 'Taille de la db healthdata', 'Cluster', 'Flag db active', 'Info de sur la release'],
      type: 'Excel'
    },
    {
      name: 'getLicenceOfAllUsersByGroupId',
      creationDate: '2023-04-27',
      title: 'Liste des licences',
      description: "Liste l'ensemble des utilisateurs actifs avec leur licence",
      isActive: true,
      exportedColumns: ['Groupe Id', 'Email', 'Date de début de la licence', 'Date de fin de la licence', 'Type de licence', 'Nom', 'Prénom', 'N°inami', 'Spécialité', 'Niss', 'Date de naissance', 'Ville (facturation)', 'Pays (facturation)', 'Data source (facturation)', 'Adresse mail (facturation)', 'Id externe (facturation)', 'Nom (facturation)', 'N°téléphone (facturation)', 'Code postal (facturation)', 'Adresse (facturation)', 'Langue', 'N° tva', 'Date de modification', 'Date du dernier log', 'Type d\'accès'],
      type: 'Excel'
    },
    {
      name: 'getActiveDBFromDate',
      creationDate: '2023-12-04',
      title: 'Liste des db actives suivant les accès logs',
      description: "Liste l'ensemble des db et indique s'il y a eu une connexion dans l'année",
      isActive: true,
      exportedColumns: ['Groupe Id', 'Date de la dernière création dans la db', 'Date de dernière modification dans la db', 'Date de l\'accès log', 'Type d\'accès'],
      type: 'Excel'
    },
    {
      name: 'getAssitantInvoicingValidation',
      creationDate: '2024-08-12',
      title: 'Liste des assitants',
      description: "Récupère les données de facturation pour les assistants",
      isActive: true,
      exportedColumns: ['Groupe Id', 'Nom', 'Prénom', 'N°inami', 'Niss', 'Email', 'Nom du maitre de stage', 'Ville (maitre de stage)', 'Pays (maitre de stage)', 'Data source (maitre de stage)', 'Email (maitre de stage)', 'External Id', 'Nom (maitre de stage)', 'N°tel (maitre de stage)', 'Code postal (maitre de stage)', 'Adresse (maitre de stage)', 'N°tva (maitre de stage)', 'Date de moification des informations', 'Prochain statut', 'Changement de structure', 'Nom (prochain maitre de stage)', 'N°inami (prochain maitre de stage)', 'Ville (prochain maitre de stage)', 'Pays (prochain maitre de stage)', 'Data source (prochain maitre de stage)', 'Email (prochain maitre de stage)', 'External Id (prochain maitre de stage)', 'N°tel (prochain maitre de stage)', 'Code postal (prochain maitre de stage)', 'Adresse (prochain maitre de stage)', 'N°tva (prochain maitre de stage)', 'Date de modification du prochain maitre de stage'],
      type: 'Excel'
    },
    {
      name: 'getDatabaseOriginSetting',
      creationDate: '2024-08-25',
      title: 'Liste des bdd avec le tag database origin',
      description: "Liste l'ensemble des bdd avec le tag database origin",
      isActive: true,
      exportedColumns: ['Groupe Id', 'Database Origin', 'Flag db icure'],
      type: 'Excel'
    },
    {
      name: 'getConfigVersionByGroupId',
      creationDate: '2024-11-06',
      title: 'Liste tous les groupId avec leur version',
      description: "Liste l'ensemble des utilisateurs de toutes les dbs avec leur configuration",
      isActive: true,
      exportedColumns: ['Date dernière modification', 'Groupe Id', 'Configuration', 'Configuration (nom)', 'Configuration (utilisateur)', 'Version de l\'OS', 'Compteur', 'Version actuelle', 'Version de couchDb', 'Version de l\'electron', 'Type d\'installation', 'Main url', 'Flag kraken', 'Flag maurice'],
      type: 'Excel'
    },
    {
      name: 'getAllUsersInfosByGroupId',
      creationDate: '2024-11-08',
      title: 'Exporter la liste des utilisateurs',
      description: "Liste l'ensemble des utilisateurs actifs par groupeId avec leurs informations",
      isActive: true,
      exportedColumns: ['Groupe Id', 'Nom', 'Prénom', 'N°inami', 'Spécialité', 'Niss', 'Flag utilisateur actif'],
      type: 'Excel'
    },
    {
      name: 'getAllGroupsThatUseOnlineAgenda',
      creationDate: '2025-01-30',
      title: "Exporte la liste de tous les groupes id qui utilisent l'agenda en ligne",
      description: "Liste l'ensemble des groupes qui utilisent l'agenda en ligne",
      isActive: true,
      exportedColumns: ['Groupe Id', 'Cluster', 'Agenda en ligne actif', 'V8 activée'],
      type: 'Excel'
    },
    {
      name: 'getAllUsersWithExpiredLicenceForWhomHaveConnection',
      creationDate: '2025-05-15',
      title: "Exporte la liste de tous les utilisateurs avec une licence expirée",
      description: "Liste l'ensemble des utilisateurs avec une licence expirée et qui se sont connectés après l'expiration de celle-ci",
      isActive: true,
      exportedColumns: ['Groupe Id', 'Email', 'Date de début de la licence', 'Date de fin de la licence', 'Type de licence', 'Nom', 'Prénom', 'N°inami', 'Spécialité', 'Niss', 'Date de la dernière connexion', 'Type d\'accès'],
      type: 'Excel'
    },
    {
      name: 'getAllUsersWithoutParentId',
      creationDate: '2025-08-18',
      title: "Exporte la liste de tous les utilisateurs qui n'ont pas de parentId",
      description: "Liste l'ensemble des utilisateurs qui n'ont pas de parentId",
      isActive: true,
      exportedColumns: ['Groupe Id', 'Nom', 'Prénom', 'N°inami', 'Spécialité', 'Niss', 'Email'],
      type: 'Excel'
    },
    {
      name: 'getActivesFeaturesByGroupId',
      creationDate: '2026-01-21',
      title: "Exporte la liste de tous les groupes avec les fonctionnalités actives",
      description: "Liste l'ensemble des groupes avec les fonctionnalités actives",
      isActive: true,
      exportedColumns: ['Groupe Id', 'Beogoo', 'Agenda', 'Dossier kiné', 'La Luna', 'Mode de connexion'],
      type: 'Excel'
    }
  ];

  public reportingList: Array<ReportingInfo> = [];
  public displayedColumns: string[] = ['creationDate', 'title', 'description', 'exportedColumns', 'type', 'action'];

  constructor(
    private reportingService: ReportingService,
  ) {

  }

  ngOnInit() {
    this.reportingList = this.availableReporting?.filter(reporting => reporting.isActive);
  }

  public async launchReporting(reportingInfo: ReportingInfo){
    this.messages.push({id: reportingInfo.name, isDone: false, message: 'Génération du rapport en cours, cela peut prendre quelques minutes...'});
    this.isLoading = true;
    await this.reportingService.launchReporting(reportingInfo);
    this.isLoading = false;
  }
}
